import { render, staticRenderFns } from "./SubjectContactsComponent.vue?vue&type=template&id=af1339a4"
import script from "./SubjectContactsComponent.vue?vue&type=script&lang=js"
export * from "./SubjectContactsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports